import React, { forwardRef, useEffect, useState } from 'react';
import DatePicker, { CalendarContainer } from 'react-datepicker';
import range from 'ramda/src/range';
import cx from 'classnames';
import moment from 'moment';

const DateRangePicker = ({
    className,
    dateFormat = 'MMM D, YYYY',
    current = false,
    selected, // 12/01/2020-12/31/2020
    title = null,
    as = 'input', // input, span
    onChange = () => {},
}) => {
    let picker;
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const years = range(1990, new Date().getFullYear() + 1);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    useEffect(() => {
        if (selected) {
            const start = selected.split('-')[0];
            const end = selected.split('-')[1];
            setDateStart(new Date(start));
            setDateEnd(end.trim() === 'Current' ? null : new Date(end));
        }
    }, []);

    const MyContainer = ({ className, children }) => {
        return (
            <CalendarContainer className={className}>
                {current && (
                    <div className="current" onClick={handleCurrent}>
                        I am currently working on this role!
                    </div>
                )}
                <div style={{ position: 'relative' }}>{children}</div>
            </CalendarContainer>
        );
    };
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <span ref={ref} className="dsl-b16" onClick={onClick}>
            {value || 'Current'}
        </span>
    ));
    CustomInput.displayName = 'CustomInput';
    const handleCurrent = () => {
        setDateEnd(null);
        picker.setOpen(false);
        const value = `${moment(dateStart).format(dateFormat)} - Current`;
        onChange(value);
    };
    const handleStart = (e) => {
        const value = `${moment(e).format(dateFormat)} - ${moment(dateEnd).format(dateFormat)}`;
        setDateStart(e);
        onChange(value);
    };
    const handleEnd = (e) => {
        const value = `${moment(dateStart).format(dateFormat)} - ${moment(e).format(dateFormat)}`;
        setDateEnd(e);
        onChange(value);
    };

    return (
        <div className={cx('ds-daterangepicker', className)}>
            {title && <span className="ds-daterangepicker-label dsl-m12">{title}</span>}
            <div className={cx('dates', as)}>
                <DatePicker
                    selected={dateStart}
                    customInput={<CustomInput />}
                    renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                        <div style={{ margin: 10, display: 'flex', justifyContent: 'center' }}>
                            <button disabled={prevMonthButtonDisabled} onClick={decreaseMonth}>
                                {'<'}
                            </button>
                            <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
                                {years.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>

                            <select value={months[date.getMonth()]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
                                {months.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>

                            <button disabled={nextMonthButtonDisabled} onClick={increaseMonth}>
                                {'>'}
                            </button>
                        </div>
                    )}
                    onChange={handleStart}
                />
                <span className="dsl-b16 mx-2">-</span>
                <DatePicker
                    selected={dateEnd}
                    calendarContainer={MyContainer}
                    customInput={<CustomInput />}
                    ref={(e) => {
                        picker = e;
                    }}
                    renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                        <div style={{ margin: 10, display: 'flex', justifyContent: 'center' }}>
                            <button disabled={prevMonthButtonDisabled} onClick={decreaseMonth}>
                                {'<'}
                            </button>
                            <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
                                {years.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>

                            <select value={months[date.getMonth()]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
                                {months.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>

                            <button disabled={nextMonthButtonDisabled} onClick={increaseMonth}>
                                {'>'}
                            </button>
                        </div>
                    )}
                    onChange={handleEnd}
                />
            </div>
        </div>
    );
};

export default DateRangePicker;
